import { RecordSummary } from 'generated/graphql';
import { Feedback, FeedbackContentType } from 'v2/core/entities/feedback';

export const getFeedbackSummary = (
  feedback: Feedback,
): RecordSummary | undefined => {
  if (feedback.content.type === FeedbackContentType.Audio) {
    return undefined;
  }

  return feedback.content.summary;
};
